import { Card } from '@popsure/dirty-swan';
import { captureException } from '@sentry/nextjs';
import LinkTo from 'components/linkTo';
import { SupportOptions } from 'content/support/supportByCountry';
import Image from 'next/image';

import { IntercomLoaderWrapper } from '../IntercomLoaderWrapper';
import styles from './style.module.scss';

interface SupportProps extends SupportOptions {
  delay: number;
}

export const SupportCard = ({
  linkType,
  genericURL,
  title,
  description,
  imgSrc,
  imgAlt,
  delay,
}: SupportProps) => {
  if (linkType === 'generic' && !genericURL) {
    const errorMessage =
      '[Support page] genericURL missing for generic linkType';
    captureException(new Error(errorMessage));
    return null;
  }

  return (
    <>
      {linkType === 'generic' && genericURL && (
        <div
          className={`wmx8 ${styles['appear-in-animation']}`}
          style={{ animationDelay: `${delay * 0.3}s` }}
        >
          <Card
            title={title}
            titleVariant="medium"
            classNames={{
              wrapper: `${styles.card} ${styles.actionableCard}`,
              icon: styles.icon,
            }}
            icon={<Image width={32} height={32} src={imgSrc} alt={imgAlt} />}
            description={description}
            as={LinkTo}
            href={genericURL}
            actionIcon={null}
          />
        </div>
      )}
      {linkType === 'intercom' && (
        <IntercomLoaderWrapper
          render={({ error, handleClick }) => (
            <div
              className={`wmx8 ${styles['appear-in-animation']}`}
              style={error ? {} : { animationDelay: `${delay * 0.3}s` }}
            >
              <Card
                classNames={{ wrapper: styles.card, icon: styles.icon }}
                title={title}
                titleVariant="medium"
                icon={
                  <Image width={32} height={32} src={imgSrc} alt={imgAlt} />
                }
                onClick={handleClick}
                description={description}
                actionIcon={null}
              />
            </div>
          )}
        />
      )}
    </>
  );
};
